/**
 * Get a random integer
 * @param {Number} min
 * @param {Number} max
 * @returns {Number}
 */
const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

/**
 * Get random image/video url from string of image urls
 * @param {String} backgrounds
 * @returns {String}
 */
export const getRandomBackground = (backgrounds) => {
  const mediaArray = backgrounds.slice(0, -1).split('@');
  return mediaArray[getRandomInt(0, mediaArray.length - 1)];
};

/**
 * Set random background
 * @param {JQuery element} $element,
 * @param {String} type background/image-src
 * @return {Void}
 */
const setRandomBackground = ($element, type) => {
  const randomImage = getRandomBackground($element.data('backgrounds'));
  if (type == 'background') {
    $element.attr('style', `background-image: url(${randomImage})`);
    return;
  }

  $element.attr('src', randomImage);
};

if ($('.js-random-background').length) {
  $('.js-random-background').map((index, backgroundDiv) => {
    setRandomBackground($(backgroundDiv), 'background');
  });
}

if ($('.js-random-image-src').length) {
  $('.js-random-image-src').map((index, image) => {
    setRandomBackground($(image), 'image-src');
  });
}
